import Vue from "vue";
import VueRouter from "vue-router";
import paths from "./paths.js";
import { auth } from "firebase";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: paths
});

// import firebase from "firebase";

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (auth().currentUser == null) {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
